import { Card, CardBody, Skeleton } from "@heroui/react";

const KandangSkeleton = () => {
    return (
        <div className="space-y-4">
            <Card className="border border-zinc-200 bg-white shadow-sm dark:border-zinc-800 dark:bg-zinc-900">
                {/* Header Skeleton */}
                <CardBody className="p-0">
                    <div className="flex flex-col gap-4 p-5 sm:flex-row sm:items-center sm:justify-between">
                        <div className="flex items-start gap-4">
                            <Skeleton className="h-10 w-10 shrink-0 rounded-xl" />
                            <div className="space-y-2">
                                <div className="flex items-center gap-2">
                                    <Skeleton className="h-6 w-32 rounded-lg" />
                                    <Skeleton className="h-5 w-16 rounded-full" />
                                    <Skeleton className="h-5 w-24 rounded-full" />
                                </div>
                                <Skeleton className="h-4 w-48 rounded-lg" />
                            </div>
                        </div>
                        <Skeleton className="h-8 w-24 rounded-lg" />
                    </div>

                    {/* Content Area Skeleton */}
                    <div className="px-5 pb-5">
                        <div className="mb-4 flex items-center gap-2">
                            <Skeleton className="mx-auto h-3 w-24 rounded" />
                        </div>

                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                            <Skeleton className="h-[140px] rounded-xl" />
                            {[1, 2, 3].map((i) => (
                                <Skeleton
                                    key={i}
                                    className="h-[140px] rounded-xl"
                                />
                            ))}
                        </div>
                    </div>
                </CardBody>
            </Card>
        </div>
    );
};

export default KandangSkeleton;
